<template>
    <div class="quote-popup">
        <button @click.prevent="toggleModal" class="quote-popup__toggle">
            {{ buttonLabel }}
        </button>
        <div v-if="modalOpen" class="quote-popup__modal showing" :class="{ 'quote-popup--pull-up': isDiscountPresent }">  
            <table>
                <thead>
                    <tr>
                        <th>Charges</th>
                        <th>Wholesale</th>
                        <th>Retail</th>
                        <th>Estimate</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in calculation.lineItems" :key="index">
                        <td>{{ item.charges }}</td> 
                        <td>{{ item.wholesale | toCurrency(2) }}</td>
                        <td>{{ item.retail | toCurrency(2) }}</td>
                        <td>{{ item.estimates | toCurrency(2) }}</td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr v-if="calculation.discount > 0">
                        <th colspan="3"> 
                            Contract discount
                        </th>
                        <th>
                            - {{ calculation.discount | toCurrency(2) }}
                        </th> 
                    </tr>
                    <tr>
                        <th colspan="3">
                            Total estimated annual charges
                        </th>
                        <th>
                            {{ calculation.total | toCurrency(2) }}
                        </th>
                    </tr>
                </tfoot>
            </table>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            openLabel: {
                type: String,
                required: false,
                default: 'See calculation',
            },

            closeLabel: {
                type: String,
                required: false,
                default: 'Hide calculation'
            },

            calculation: {
                type: Object,
                required: true,
            },

            length: {
                type: String,
                required: true,
            }
        },

        data() {
            return {
                modalOpen: false,
            }
        },

        computed: {
            isDiscountPresent() { 
                return this.calculation.discount > 0;
            },

            buttonLabel() {
                if (this.modalOpen) {
                    return this.openLabel;
                } else {
                    return this.closeLabel;
                }
            }
        },

        methods: {
            toggleModal() {
                this.modalOpen = !this.modalOpen;

                if (this.modalOpen) {
                    this.$emit('open', {
                        length: this.length
                    })
                }
            },

            hideModal(event) {
                this.modalOpen = false;
            }
        }

    }
</script>